import { render, staticRenderFns } from "./SettingsRegExp.vue?vue&type=template&id=7ea127c1&scoped=true"
import script from "./SettingsRegExp.vue?vue&type=script&lang=js"
export * from "./SettingsRegExp.vue?vue&type=script&lang=js"
import style0 from "./SettingsRegExp.vue?vue&type=style&index=0&id=7ea127c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea127c1",
  null
  
)

export default component.exports